import {createContext} from 'react';

const BookingFormContext = createContext();

export default BookingFormContext;
